import { createFileRoute } from '@tanstack/react-router';
import { OffersInboxPage } from '../../features/rfq';

export const Route = createFileRoute('/portal/offers/')({ component: OffersInboxPage });
